import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

import { ProfileUnsavedChangesDialogComponent } from '@main-client/src/app/profile/profile-unsaved-changes-dialog/profile-unsaved-changes-dialog.component';
import { ProfileViewComponent } from '@main-client/src/app/profile/profile-view/profile-view.component';

import { IAppState } from '@main-client/src/app/app.state';

@Injectable()
export class CanDeactivateProfileEditGuardService
  implements CanDeactivate<ProfileViewComponent>
{
  constructor(
    private dialog: MatDialog,
    private store: Store<IAppState>,
  ) {}

  canDeactivate(
    component: ProfileViewComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
  ) {
    return this.store.select('profile').pipe(
      take(1),
      switchMap((profile) => {
        if (profile.isEdited) {
          const config: any = {
            autoFocus: false,
          };
          return this.dialog
            .open(ProfileUnsavedChangesDialogComponent, config)
            .afterClosed()
            .pipe(map((discardChanges: boolean) => discardChanges));
        }
        return of(true);
      }),
    );
  }
}
